import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceflowForm from '@sourceflow-uk/sourceflowform';
import {
    Container,
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Collapse
} from "reactstrap";
import styles from './styles.module.scss';
import Link from 'next/link';
import React, { useState } from 'react';
import { trackMetaEvent } from "../../functions/metaPixel";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TestimonialCard from '/components/TestimonialCard';
import Arrow from '/public/site-assets/svg/right-arrow.svg';
import Locations from "../../.sourceflow/locations.json";

export default function WhyDrivingForce({
    global,
    pathPrefix,
    customClass = "",
    formId,
    heading,
    all_testimonials,
    subheading,
    column1 = true,
    column2 = true,
    fullWidthColumn = false,
    // TestimonialCardColumn2 = false,
    TestimonialCardfullWithColumn = true,
    testimonialCardCustomClass,
    form_header = "Let's make sure you get in touch with the right team"

}) {

    const [state, setState] = React.useState({});

    const { article } = state;
    React.useEffect(() => {
        setState((prevState) => ({
            moreInfoOpen: true
        }));
        // handleArticleOpen("0");
        handleArticleOpen("");

    }, []);

    const handleArticleOpen = (article) => {
        setState((prevState) => ({
            ...prevState,
            article
        }));

    };
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    const [selectedItem, setSelectedItem] = useState("Select Branch");


    const [modal, setModal] = useState(false);
    const toggle_modal = () => setModal(!modal);

    const slider = React.useRef(null);
    var settings = {
        autoplay: false,
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 6500,
        fade: true,
        cssEase: 'linear',
        adaptiveHeight: true
    };
    return (
        <>
            <section className={`${styles.root} ${customClass}`} >
                <Container>
                    <Row>
                        {column1 ?
                            <Col lg={8} className={`${fullWidthColumn ? "w-100" : ""} mb-4 mb-lg-0`}>
                                <div className="testimonial-wrapper rounded-3 p-lg-5 p-4 h-100">
                                    <div className="d-flex justify-content-between align-items-start align-items-md-start mb-4">
                                        <div>
                                            <h2>
                                                <SourceFlowText global={global} path={`${pathPrefix}.heading`}>
                                                    {heading}
                                                </SourceFlowText>
                                            </h2></div>
                                        {all_testimonials.length >= 2 && (
                                            <div className="d-flex flex-nowrap">
                                                <button className="custom-arrow prev" onClick={() => slider?.current?.slickPrev()} aria-label="Prev"><Arrow /></button>
                                                <button className="custom-arrow next" onClick={() => slider?.current?.slickNext()} aria-label="Next"><Arrow /></button>
                                            </div>
                                        )}
                                    </div>
                                    <Slider ref={slider} {...settings}>
                                        {all_testimonials?.map((post, index) => (
                                            <TestimonialCard
                                                key={index}
                                                post={post}
                                                column2={false}
                                                fullWithColumn={TestimonialCardfullWithColumn}
                                                customClass={testimonialCardCustomClass}
                                            />
                                        ))}
                                    </Slider>
                                </div>
                            </Col> : ""}
                        {column2 ?
                            <Col lg={4} className={`${fullWidthColumn ? "w-100" : ""} right`}>
                                <div className="form-wrapper rounded-3 p-lg-5 p-4">
                                    <h2>
                                        <SourceFlowText global={global} path={`${pathPrefix}.subheading`}>
                                            {subheading}
                                        </SourceFlowText>
                                    </h2>
                                    {/* <SourceflowForm onSubmitDone={toggle_modal} formId={formId} /> */}
                                    <div className="d-flex flex-wrap aligm-items-center custom-dropdown">
                                        <div className="mb-2 text-white">
                                            <SourceFlowText global={global} path={`${pathPrefix}.form_header`} type="html">
                                                {form_header}
                                            </SourceFlowText>
                                        </div>
                                        <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                                            <DropdownToggle>{selectedItem}</DropdownToggle>
                                            <DropdownMenu>
                                                {Locations.category_values?.map((post, index) => (
                                                    post.sourceflow_embed_form_api.en ?
                                                        <DropdownItem key={index} onClick={() => { handleArticleOpen(`${index}`); setSelectedItem(`${post.title.en}`) }} className={`${article === `${index}` ? "active" : ""}`}>{post.title.en}</DropdownItem>
                                                        : ""
                                                ))}
                                            </DropdownMenu>
                                        </Dropdown>
                                    </div>
                                    {Locations.category_values?.map((post, index) => (
                                        post.sourceflow_embed_form_api.en ?
                                            <Collapse isOpen={article === `${index}`} key={index}>
                                                <SourceflowForm onSubmitDone={() => { trackMetaEvent("Lead"); toggle_modal(); }} formId={post.sourceflow_embed_form_api.en} />
                                            </Collapse> : ""))}
                                    {modal ?
                                        <Modal isOpen={modal} toggle={toggle_modal}>
                                            <ModalHeader toggle={toggle_modal} tag={"div"}>
                                                <div className="w-100 text-center">
                                                    <h5 className="heading mb-0"><strong> Submission Success</strong></h5>
                                                </div>
                                            </ModalHeader>
                                            <ModalBody>
                                                <p>Your submission has been successfully submitted.</p>
                                                <p>We will be in touch shortly!</p>
                                            </ModalBody>
                                        </Modal> : null
                                    }
                                </div>
                            </Col> : ""}

                    </Row>
                </Container>
            </section>
        </>
    )
}